module.exports = __webpack_public_path__ + "static/media/dd_logo.7aec5fe5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dd_logo.jpg
// module id = 358
// module chunks = 0